/**
 * The leaderboard's "Last active" filter as the server wants it: whole days in
 * the admin's own time zone, sent as instants — from the start of the first
 * day to the start of the day AFTER the last one (exclusive). Empty = open.
 */
export function lastActiveRange(from: string, to: string): {
  lastActiveFrom: string | null; lastActiveBefore: string | null; problem: string | null;
} {
  const start = (day: string) => new Date(`${day}T00:00:00`);
  const valid = (day: string) => /^\d{4}-\d{2}-\d{2}$/.test(day) && !Number.isNaN(start(day).getTime());
  const none = { lastActiveFrom: null, lastActiveBefore: null };
  if ((from && !valid(from)) || (to && !valid(to))) return { ...none, problem: 'Enter dates as YYYY-MM-DD' };
  if (from && to && from > to) return { ...none, problem: 'The first day must not be after the last one' };
  let before: string | null = null;
  if (to) {
    const next = start(to);
    next.setDate(next.getDate() + 1);
    before = next.toISOString();
  }
  return { lastActiveFrom: from ? start(from).toISOString() : null, lastActiveBefore: before, problem: null };
}
